
{
  "nav.startHere": "Comenzar aquí",
  "nav.about": "Acerca de",
  "nav.protocols": "Protocolos",
  "nav.tools": "Herramientas",
  "nav.compliance": "Cumplimiento",
  "nav.personal": "Protocolo personal",
  "nav.organization": "Protocolo organizacional",
  "nav.mission": "Misión y visión",
  "nav.scope": "Alcance y no garantía",
  "nav.standards": "Mapeo de estándares",
  "nav.changelog": "Registro de cambios",
  "nav.governance": "Gobernanza",
  "nav.disclaimer": "Descargo de responsabilidad legal",
  "nav.contact": "Contáctenos",
  
  "hero.title1": "Asegure su",
  "hero.title2": "Mundo digital",
  "hero.subtitle": "Una plataforma global de protocolo de ciberseguridad y preparación para individuos y organizaciones. Basada en prácticas estándar de la industria y marcos de seguridad globales.",
  "hero.cta.start": "Iniciar evaluación de seguridad",
  "hero.cta.learn": "Saber más",
  "hero.trust.standards": "Alineado con estándares",
  "hero.trust.standardsDesc": "Mejores prácticas globales",
  "hero.trust.defensive": "Solo defensivo",
  "hero.trust.defensiveDesc": "Orientación de seguridad ética",
  "hero.trust.global": "Plataforma global",
  "hero.trust.globalDesc": "Protocolos internacionales",
  
  "home.tab.personal": "Protocolo personal",
  "home.tab.organization": "Protocolo organizacional",
  "home.personal.title": "Comience con estos 10 pasos",
  "home.personal.desc": "Controles de seguridad esenciales que cada individuo debe implementar de inmediato para prevenir el 90% de los ataques comunes.",
  "home.org.title": "Línea base de seguridad organizacional",
  "home.org.desc": "Controles de gobernanza y técnicos esenciales que cada organización debe establecer para reducir el riesgo cibernético y mejorar la resiliencia.",
  "home.org.note": "Estos pasos representan una línea base mínima que las organizaciones pueden implementar de inmediato, independientemente del tamaño o la industria.",
  "home.principle1.title": "Defensa en profundidad",
  "home.principle1.titleOrg": "Seguridad en capas",
  "home.principle1.desc": "Aplicar múltiples controles de seguridad independientes para que el fallo de un solo control no comprometa la seguridad general.",
  "home.principle1.descOrg": "Múltiples controles independientes para que si uno falla, los demás permanezcan efectivos.",
  "home.principle2.title": "Mentalidad de confianza cero",
  "home.principle2.titleOrg": "Verificación continua",
  "home.principle2.desc": "No confíe en la confianza implícita. Verifique continuamente el acceso basándose en la identidad, el dispositivo y el contexto.",
  "home.principle2.descOrg": "Verifique cada solicitud de acceso y asuma un compromiso potencial en todo momento.",
  "home.standards.badge": "Enfoque basado en estándares",
  "home.standards.title": "Construido sobre estándares de seguridad globales",
  "home.standards.desc": "Nuestros protocolos están rigurosamente alineados con marcos de ciberseguridad y mejores prácticas reconocidos internacionalmente.",
  "home.standards.risk.title": "Gestión de riesgos",
  "home.standards.risk.desc": "Enfoque integral basado en riesgos para la gobernanza de ciberseguridad y la resiliencia operativa.",
  "home.standards.risk.functions": "Gobernar, identificar, proteger, detectar, responder, recuperar",
  "home.standards.controls.title": "Controles de seguridad",
  "home.standards.controls.desc": "Estándar internacional para sistemas de gestión de seguridad de la información con controles integrales.",
  "home.standards.controls.count": "114 controles de seguridad en 14 dominios",
  "home.standards.practices.title": "Mejores prácticas",
  "home.standards.practices.desc": "Controles de seguridad priorizados y accionables para defenderse de los ciberataques más comunes.",
  "home.standards.practices.count": "18 controles de seguridad críticos",
  "home.standards.cta": "Ver mapeo completo de estándares",
  
  "footer.brand.desc": "Una plataforma global de protocolo de ciberseguridad y preparación para individuos y organizaciones.",
  "footer.brand.note": "Orientación de seguridad defensiva alineada con estándares.",
  "footer.protocols": "Protocolos",
  "footer.resources": "Recursos",
  "footer.about": "Acerca de",
  "footer.riskAssessment": "Evaluación de riesgos",
  "footer.toolsLibrary": "Biblioteca de herramientas",
  "footer.complianceGuides": "Guías de cumplimiento",
  "footer.standardsMapping": "Mapeo de estándares",
  "footer.missionVision": "Misión y visión",
  "footer.scopeDisclaimer": "Alcance y descargo",
  "footer.contact": "Contacto",
  "footer.copyright": "CyberSecurityProtocol. Todos los derechos reservados.",
  "footer.educational": "Solo orientación de ciberseguridad educativa y defensiva.",
  "footer.legal": "Legal",
  "footer.nonGuarantee": "No garantía",
  "footer.builtBy": "Construido por UXER — Parte de la Asociación de Tecnología de la Información y Código Abierto (ATIOS)",
  
  "common.loading": "Cargando...",
  "common.error": "Error",
  "common.success": "Éxito",
  "common.cancel": "Cancelar",
  "common.save": "Guardar",
  "common.continue": "Continuar",
  "common.back": "Atrás",
  "common.next": "Siguiente",
  "common.finish": "Finalizar",
  "common.viewMore": "Ver más",
  "common.learnMore": "Saber más",
  "common.getStarted": "Comenzar"
}
